import { createReducer } from '@reduxjs/toolkit';
import { ApiActionStatus, type BookingState } from '@/interfaces';

import {
    setCustomer,
    createProduct,
    paymentError,
    setReservation,
    setReservationSuccess,
    setReservationFailure,
    createVerification,
    createVerificationSuccess,
    createVerificationFailure,
    createVerificationReset,
} from './actions';

export const initialState: BookingState = {};

export const reducer = createReducer<BookingState>(initialState, (builder) => {
    builder
        .addCase(setCustomer, (state, action) => {
            state.customer = action.payload;
        })
        .addCase(createProduct, (state, action) => {
            state.product = action.payload;
        })
        .addCase(paymentError, (state, action) => {
            state.status = { ...state.status, errorCode: action.payload };
        })
        .addCase(setReservation, (state) => {
            state.reservation = { status: ApiActionStatus.PENDING };
        })
        .addCase(setReservationSuccess, (state, action) => {
            state.reservation = { ...action.payload, status: ApiActionStatus.OK };
        })
        .addCase(setReservationFailure, (state) => {
            state.reservation = { status: ApiActionStatus.ERROR };
        })
        .addCase(createVerification, (state, action) => {
            state.status = {
                verification: { [action.payload]: 'pending' },
            };
        })
        .addCase(createVerificationSuccess, (state, action) => {
            state.status = {
                verification: { [action.payload]: 'verified' },
            };
        })
        .addCase(createVerificationFailure, (state, action) => {
            state.status = {
                verification: { [action.payload]: 'unverified' },
            };
        })
        .addCase(createVerificationReset, (state) => {
            state.status = {
                verification: { email: undefined, phone: undefined },
            };
        });
});
